import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../../../../store/app-state';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  loading$

  constructor(private store: Store<AppState>) {
    this.loading$ = this.store.select(state => state.main.isLoading);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/component/core/loading/loading.component.ts